// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1h4VN","bigColWidth":"Table_bigColWidth__3HEq6","biggerColWidth":"Table_biggerColWidth__16jlL","row":"Table_row__1MV-k","col":"Table_col__vs00I"};